import React from "react";

export const Contact = () => {
  return (
    <div>
      <h1>Contact Us</h1>
    </div>
  );
};
